function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var indicator = require('./indicator');

function ordinal(i) {
  if (typeof i !== 'number') throw new TypeError('Expected Number, got ' + _typeof(i) + ' ' + i);
  if (!Number.isFinite(i)) return i;
  return i + indicator(i);
}

ordinal.indicator = indicator;
module.exports = ordinal;